module.exports = __webpack_public_path__ + "img/Start-Screen.d7c505dc.jpg";